// @ts-nocheck
/* eslint-enable */
// App
import React, { useEffect } from 'react';
import { useSelector } from 'react-redux';

// Hooks
import { useFilterPills } from 'app/shared/modules/MobileSRP/ListingCards/FilterPills/useFilterPills';

// Misc / utils
import numberUtils from 'app/shared/utils/numberUtils';
import * as S from './styles';

const FilterPills = () => {
  // Redux
  const totalListings = useSelector((state) => state.listings.totalListings);
  const numDefaultFilterListings = useSelector((state) => state.listings.numDefaultFilterListings);

  const listingsExcluded = numDefaultFilterListings - totalListings;

  // Hooks
  const { initialize, handleClearAllFilters, handleFilterItemRemoval, filterLabels, filterLabelCounts, isLoading } =
    useFilterPills();

  // When component mounts, initialize and get filter counts
  useEffect(() => {
    initialize();
  }, []);

  if (isLoading || !filterLabels?.length) {
    return null;
  }

  return (
    <S.FilterTabsArticle>
      {listingsExcluded > 0 && (
        <>
          <S.ExcludedText>
            {numberUtils.prettyPrintNumber(listingsExcluded)}
            <S.SecondaryExcludedText as="span">properties are excluded</S.SecondaryExcludedText>
          </S.ExcludedText>
          <S.RemoveSomeFiltersText>Remove some filters?</S.RemoveSomeFiltersText>
        </>
      )}
      <S.FilterLabelsContainer>
        {filterLabels.map((label) => {
          const key = label[0];
          const filterLabel = label[1];

          return (
            <S.FilterPill
              key={`filter-pill-${key}-${filterLabel}`}
              filterKey={key}
              onItemClearClick={handleFilterItemRemoval}
            >
              {filterLabel}
              {filterLabelCounts[key] && <S.FilterPillCount>{`(${filterLabelCounts[key]})`}</S.FilterPillCount>}
            </S.FilterPill>
          );
        })}
      </S.FilterLabelsContainer>
      <S.ClearAllFiltersButton onClick={handleClearAllFilters}>Clear all filters</S.ClearAllFiltersButton>
    </S.FilterTabsArticle>
  );
};

export default FilterPills;
